import React from "react";
import { SNavigation, SPage, STheme, SView } from "servisofts-component2";
import Logo from "../Assets/svg/registro/logo.svg"
import Container from "../Components/Container";
import MDL from "../MDL";
export default class Carga extends React.Component {

    componentDidMount(): void {
        setTimeout(() => {
            if(!MDL.usuario.session){
                SNavigation.replace("/login");
                return;
            }
            SNavigation.replace("/root");
        }, 1000);
    }
    render() {
        return <SPage disableScroll hidden>
            <Container flex>
                <Logo fill={STheme.color.secondary} width={"100%"} height={"100%"} />
            </Container>
        </SPage>
    }
}